// Modelo de dados da marca d'agua (painel + bot).
//
// Tudo que e posicao/tamanho e NORMALIZADO (0..1) sobre a tela quadrada de
// saida: o painel salva fracoes, o renderizador do bot multiplica pelo tamanho
// real. Assim a previa e o envio usam exatamente os mesmos numeros.
/** Lado da imagem gerada (quadrada), em pixels. */
export const WATERMARK_CANVAS_SIZE = 1080;
/** Fluxos de envio onde a marca d'agua pode ser aplicada. */
export const WATERMARK_FLOWS = [
    "forwarding",
    "auto_promotions",
    "scheduled_posts",
    "ai_images",
];
export const WATERMARK_PRESET_IDS = [
    "assinatura",
    "cartaz",
    "fita",
    "etiqueta",
    "vitrine",
];
export const WATERMARK_LAYER_KINDS = ["text", "badge", "contacts", "logo"];
export const MAX_WATERMARK_LAYERS = 8;
export const MAX_WATERMARK_TEXT = 120;
/** Menor lado de uma camada (fracao da tela): evita caixa invisivel. */
export const MIN_LAYER_SIZE = 0.04;
export const BAND_SIZE_MIN = 0.06;
export const BAND_SIZE_MAX = 0.25;
export const MAX_ROTATION = 45;
export const MIN_LOGO_OPACITY = 0.1;
/** Logo do tenant: PNG/JPEG/WebP ate 2 MB (espelhado no bucket). */
export const WATERMARK_LOGO_MAX_BYTES = 2 * 1024 * 1024;
export const WATERMARK_LOGO_MIME_TYPES = ["image/png", "image/jpeg", "image/webp"];
export const WATERMARK_TEXT_VARIABLES = [
    "title",
    "price",
    "originalPrice",
    "discountPercent",
    "coupon",
];
//# sourceMappingURL=types.js.map